<template>
	<div class="shop-list-box js-shop-list-box">
		<a v-if="showSwitchBtn" :class="{'switch-shop-btn': true, 'prev-btn': true, 'icon': true, 'icon-zuo': true, 'disabled': leftBtnDisabled}" href="javascript:;" @click="aleftSwitchList"></a>
		<div class="box js-store-box">
			<ul class="store clear" :style="storeUlStyle">
				<template v-for="s in $store.state.shopList">
					<li :class="{'shop-li reception-li': true, 'reception-status': s.receptionStatus && $store.state.userStatus == 'on', active: s.id == $store.state.currentShop.id}" :data-id="s.id" :data-merchant="s.shopName ? s.shopName : '[未填写名称]'" :title="s.shopName ? s.shopName : '[未填写名称]'" @click="switchCurrentShop(s)">
						<span v-if="s.shopName">{{s.shopName}}</span>
						<span v-else>[未填写名称]</span>

						<b :class="{unread: true, show: s.unreadNum > 0}" :data-num="s.unreadNum">
							<template v-if="s.unreadNum > 99">99+</template>
							<template v-else>{{s.unreadNum}}</template>
						</b>
					</li>
				</template>
				<li :class="{'shop-li': true, active: -1 == $store.state.currentShop.id}" :data-id="-1" :data-merchant="'离线消息'" :title="'离线消息'" @click="switchCurrentShop({'id': -1})">
					<span>离线消息</span>
				</li>
			</ul>
		</div>
		<a v-if="showSwitchBtn" :class="{'switch-shop-btn': true, 'next-btn': true, 'icon': true, 'icon-you': true, 'disabled': rightBtnDisabled}" href="javascript:;" @click="rightwardSwitchList"></a>
	</div>
</template>

<script>
import Logan from 'logan-web';
export default {
	name: 'shopList',
	data () {
		return {
			showSwitchBtn: false,
			storeUlStyle: {
				left: '0px',
				width: 'auto'
			},
			leftBtnDisabled: true,
			rightBtnDisabled: false
		}
	},
	computed: {
		userInfo () {
			return this.$store.state.userInfo;
		},
		serviceTypes () {
			return this.$store.state.serviceTypes;
		},
		changeZuiDaHua () {
			return this.$store.state.setImObj.zuidahua;
		}
	},
	watch: {
		userInfo: {
			deep: true,
			handler () {
				var self = this;
				if (self.userInfo.id) self.getShopList();
			}
		},
		changeZuiDaHua () {
			this.$nextTick(() => {
				this.initShopListStyle();
			});
		}
	},
	methods: {
		// 新手引导
		guide () {
			var self = this,
				num = localStorage.getItem('visitsNum') ? (localStorage.getItem('visitsNum') * 1 + 1) : 1; 

			if (num <= 3) {
				localStorage.setItem('visitsNum', num);
				self.$message({
					message: '欢迎使用新版IM工作台，首次使用请先导入快捷回复',
					iconClass: 'el-message__icon el-icon-success',
					customClass: 'diy-el-message',
					duration: 5000
				});
			}
		},

		// 获取店铺列表
		getShopList () {
			var self = this;

			self.$axios.post(API_ROOT.url + '/ShopInfoApi.getShopList').then(result => {
				if (result.status) {
					self.$store.commit('changeShopList', result.data);
					self.initAiIntelligentDetection();

					for (var i = 0; i < result.data.length; i++) {
						var data = {
							serviceType: result.data[i].serviceType,
							shopId: result.data[i].id,
							sessionOrder: 'asc',
							sortBy: 'startTime',
							closed: 0
						};
						let sign = i;
						self.$axios.post(API_ROOT.url + '/SessionApi.getSessionList', data).then(sRes => {
							if (!sRes.status) return
							TJ_DB.add(TJ_DB.C_Table, sRes.data, () => {
								!sign && self.switchCurrentShop(result.data[0]);
							});
						})
					}

					self.$nextTick(() => {
						self.initShopListStyle();
					});

					for (var i = 0; i < result.data.length; i++) {
						var serviceType = result.data[i].serviceType,
							index = self.serviceTypes.indexOf(serviceType);

						if (index < 0) self.serviceTypes.push(serviceType);
					}
					self.$store.commit('changeServiceTypes', self.serviceTypes);
					self.guide();
				} else {
					self.$alert('获取店铺列表失败，失败原因：' + result.msg);
				}
			}, response => {
				self.$alert('获取店铺列表失败，错误码(' + response + ')');
			})
		},

		// 切换当前店铺
		switchCurrentShop (obj) {
			var self = this;
			Logan.log('switch current store to ' + obj.id, 1);
			self.$store.commit('changeCurrentShop', obj);
		},

		// 初始化店铺列表样式
		initShopListStyle () {
			var self = this,
				ulWidth = 0,
				boxWidth = document.getElementsByClassName('js-store-box')[0].offsetWidth,
				$shopList = document.getElementsByClassName('shop-li');

			self.showSwitchBtn = false;
			self.storeUlStyle.left = '0px';
			self.storeUlStyle.width = 'auto';
			self.leftBtnDisabled = true;
			self.rightBtnDisabled = false;

			for (var i = 0; i < $shopList.length; i++) {
				var w = $shopList[i].offsetWidth + 36;
				ulWidth += w;
			}
			ulWidth -= 15;
			if (ulWidth <= boxWidth) return;
			self.storeUlStyle.width = ulWidth + 'px';
			self.showSwitchBtn = true;
		},

		// 向左切换店铺列表
		aleftSwitchList () {
			var self = this,
				oldLeft = parseFloat(self.storeUlStyle.left),
				boxWidth = document.getElementsByClassName('js-store-box')[0].offsetWidth,
				left = oldLeft + boxWidth,
				ulWidth = parseFloat(self.storeUlStyle.width);

			if (left >= 0) {
				left = 0;
				self.leftBtnDisabled = true;
			}
			self.rightBtnDisabled = false;
			self.storeUlStyle.left = left + 'px';
		},

		// 向右切换店铺列表
		rightwardSwitchList () {
			var self = this,
				oldLeft = parseFloat(self.storeUlStyle.left),
				boxWidth = document.getElementsByClassName('js-store-box')[0].offsetWidth,
				left = oldLeft - boxWidth,
				ulWidth = parseFloat(self.storeUlStyle.width);

			if (boxWidth - left >= ulWidth) {
				left = boxWidth - ulWidth;
				self.rightBtnDisabled = true;
			}
			self.leftBtnDisabled = false;
			self.storeUlStyle.left = left + 'px';
		},

		// 初始化AI智能检测接口
		initAiIntelligentDetection () {
			var self = this,
				data = {
					customerId: self.userInfo.id,
					shopIds: []
				};

			for (var i = 0; i < self.$store.state.shopList.length; i++) {
				var shopId = self.$store.state.shopList[i].id;
				data.shopIds.push(shopId);
			}

			data.shopIds = JSON.stringify(data.shopIds);
			$.ajax({
				url: API_ROOT.detectionUrl + '/reminder/init.do',
				data: data,
				type: 'get',
				contentType: "application/json;charset=UTF-8"
			}).done(function(result) {
			}).fail(function(result) {
			});
		}
	}
}
</script>
<style lang="less" scoped>
.reception-li {
	padding-left: 6px;
	&:before {
		position: absolute;
		left: 0;
		top: calc(50% - 2px);
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: #ccc;
		content: '';
	}
	&.reception-status:before {
		background-color: #67C23A;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/head/shopList.vue